import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  getJobDepartments,
  getJobFunctions,
} from '@modules/reports/store/referral-reports.selectors';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import {
  BASIC_JOB_STATUSES_FILTER_OPTIONS,
  JobStatusFilterOption,
  PUBLISHED_JOB_STATUSES,
} from '@shared/models/job-statuses';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import {
  allDepartments,
  allFunctions,
} from '@modules/reports/models/all-functions-and-departments';

@Component({
  selector: 'mojo-functions-and-departments-filters',
  styleUrls: ['./functions-and-departments-filters.component.scss'],
  templateUrl: './functions-and-departments-filters.component.html',
})
export class FunctionsAndDepartmentsFiltersComponent {
  allFunctions = allFunctions;
  allDepartments = allDepartments;
  previousSelectedFunction = allFunctions;
  @Output() filterChange = new EventEmitter();
  @Output() jobStatusChange = new EventEmitter();
  @Output() datePickerValuesChange = new EventEmitter();
  @Input() set jobStatusFilterFn(isJobStatusFilterEnabled: boolean) {
    this.jobStatusFilter = isJobStatusFilterEnabled;
    this.selectedJobStatus = BASIC_JOB_STATUSES_FILTER_OPTIONS[0];
    this.statuses = BASIC_JOB_STATUSES_FILTER_OPTIONS;
  }
  @Input() datePickerFilter = false;
  @Input() selectedDepartment = this.allDepartments;
  @Input() set pipelineJobStatusFn(isPipelineJobStatusEnabled: boolean) {
    this.pipelineJobStatus = isPipelineJobStatusEnabled;
    this.selectedJobStatus = PUBLISHED_JOB_STATUSES[0];
    this.statuses = PUBLISHED_JOB_STATUSES;
  }
  @Input() set selectedFunctionFn(selectedFunction: string) {
    this.selectedFunction = selectedFunction;
    this.isDisabled = this.selectedFunction === this.allFunctions;
  }

  get selectedFunctionFn(): string {
    return this.selectedFunction;
  }
  @Input() minDate = null;

  jobStatusFilter = false;
  pipelineJobStatus = false;
  selectedFunction = this.allFunctions;
  isDisabled = true;
  selectedJobStatus: JobStatusFilterOption;
  statuses: JobStatusFilterOption[];
  todayDate = new Date();
  dateMinus30Days = new Date(new Date().setDate(new Date().getDate() - 30));
  range = new UntypedFormGroup({
    start: new UntypedFormControl(this.dateMinus30Days, Validators.required),
    end: new UntypedFormControl(new Date(), Validators.required),
  });
  isDatePickerFilled() {
    return !this.range.invalid;
  }

  functionOptions$ = this.store
    .select(getJobFunctions)
    .pipe(map((list) => [this.allFunctions, ...list.filter(Boolean)]));

  departmentOptions$ = this.store
    .select(getJobDepartments)
    .pipe(map((list) => [this.allDepartments, ...list.filter(Boolean)]));

  constructor(private store: Store<{}>) {}

  selectionChanged() {
    this.isDisabled = this.selectedFunction === this.allFunctions;
    this.selectedDepartment =
      this.selectedFunction === this.allFunctions ||
      this.selectedFunction !== this.previousSelectedFunction
        ? this.allDepartments
        : this.selectedDepartment;
    this.filterChange.emit({
      selectedFunction: this.selectedFunction,
      selectedDepartment: this.selectedDepartment,
    });
    this.previousSelectedFunction = this.selectedFunction;
  }

  jobStatusFilterChanged() {
    this.jobStatusChange.emit(this.selectedJobStatus.value);
  }
  clearDatePicker() {
    this.range.reset();
    this.datePickerValuesChange.emit(this.range);
  }
  datePickerStatusChange() {
    this.datePickerValuesChange.emit(this.range);
  }
}
